<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <label>Tipo de movimento</label>
                  <v-select v-model="movimento.tipo_movimento_id" class="vselect" :options="tipo_movimentos"
                    :label="'nome'"></v-select>
                </div>
                <div class="col-md-6">
                  <label>Unidade</label>
                  <v-select v-model="movimento.unidade_id" class="vselect" :options="unidades"
                    :reduce="(unidades) => unidades.id" :label="'nome'"></v-select>
                </div>
                <div class="col-md-12">
                  <label>Descrição</label>
                  <ckeditor :editor="editor" v-model="movimento.descricao" :config="editorConfig"></ckeditor>
                </div>
                <div class="col-md-3 mt-2 mb-2">
                  <label>Nota Fiscal</label>
                  <input type="number" class="form-control" v-model="movimento.nota_fiscal" min="0" />
                </div>
                <div class="col-md-3 mt-2 mb-2">
                  <label>Data da Nota Fiscal</label>
                  <input type="date" class="form-control" v-model="movimento.data_nota_fiscal" />
                </div>
                <div class="col-md-3 mt-2 mb-2">
                  <label>Número de Empenho</label>
                  <input type="number" class="form-control" v-model="movimento.numero_empenho" min="0" />
                </div>
                <div class="col-md-3 mt-2 mb-2">
                  <label>Rede FES</label>
                  <v-select v-model="movimento.rede_fes" class="vselect" :options="[
                    { value: true, label: 'Sim' },
                    { value: false, label: 'Não' }
                  ]" :reduce="(option) => option.value" :label="'label'"></v-select>
                </div>
                <div class="col-md-12">
                  <hr />
                </div>
                <div class="col-md-3">
                  <label>Material</label>
                  <v-select v-model="movimento.material_id" class="vselect" :options="materiais"
                    :reduce="(materiais) => materiais.id" :label="'nome'" @input="getLotes()" id="materiais"></v-select>
                </div>
                <div class="col-md-1" v-if="movimento.tipo_movimento_id">
                  <label>Lote</label>
                  <input type="text" class="form-control" v-if="movimento.tipo_movimento_id.tipo == 'E'"
                    v-model="movimento.lote" />
                  <v-select v-if="movimento.tipo_movimento_id.tipo == 'S'" v-model="movimento.lote" class="vselect"
                    :label="'lote'" :reduce="(lotes) => lotes.lote" :options="lotes" @input="setValidade">
                    <template v-slot:no-options>
                      <span>Nenhum lote disponível.</span>
                    </template>
                  </v-select>
                </div>
                <div class="col-md-2" v-if="movimento.tipo_movimento_id">
                  <label>Fabricante</label>
                  <v-select v-model="movimento.fabricante_id" class="vselect" :options="fabricantes"
                    :reduce="(fabricantes) => fabricantes.id" :label="'nome_fantasia'" id="fabricante"
                    :disabled="movimento.tipo_movimento_id.tipo == 'S'"></v-select>
                </div>
                <div class="col-md-2" v-if="movimento.tipo_movimento_id">
                  <label>Fornecedor</label>
                  <v-select v-model="movimento.fornecedor_id" class="vselect" :options="fornecedores"
                    :reduce="(fornecedores) => fornecedores.id" :label="'nome_fantasia'" id="fornecedor"
                    :disabled="movimento.tipo_movimento_id.tipo == 'S'"></v-select>
                </div>
                <div class="col-md-2" v-if="movimento.tipo_movimento_id">
                  <label>Data de validade</label>
                  <input type="date" class="form-control" v-model="movimento.validade"
                    :disabled="movimento.tipo_movimento_id.tipo == 'S'" />
                </div>
                <div class="col-md-1">
                  <label>Quantidade</label>
                  <input type="number" class="form-control" v-model="movimento.quantidade" min="1" />
                </div>
                <div class="col-md-2" v-if="movimento.tipo_movimento_id">
                  <label>Preço</label>
                  <input type="number" class="form-control" v-model="movimento.preco_medio" step="0.01" min="0" />
                </div>
                <div class="col-md-1">
                  <label>Adicionar</label>
                  <button class="btn btn-primary" @click="add">
                    <i class="fa fa-plus" />
                  </button>
                </div>

                <div class="col-md-12 mt-3">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Material Nome</th>
                        <th>Fabricante Nome</th>
                        <th>Fornecedor Nome</th>
                        <th>Lote</th>
                        <th>Validade</th>
                        <th>Quantidade</th>
                        <th>Preço</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(movimento_item, id) in movimentos" :key="id">
                        <td>{{ movimento_item.material_nome }}</td>
                        <td>{{ movimento_item.fabricante_nome }}</td>
                        <td>{{ movimento_item.fornecedor_nome }}</td>
                        <td>{{ movimento_item.lote }}</td>
                        <td>{{ movimento_item.validade }}</td>
                        <td>{{ movimento_item.quantidade }}</td>
                        <td>{{ movimento_item.preco_medio }}</td>
                        <td>
                          <button class="btn btn-danger" @click="remove(id)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="col-md-12 text-right">
                  <hr />
                  <router-link to="/movimentos" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left" />
                    Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Moment from "moment";

export default {
  name: "imageUpload",
  data() {
    return {
      lotes: [],
      materiais: [],
      fabricantes: [],
      fornecedores: [],
      movimento: {
        fornecedor_id: "",
        fabricante_id: "",
        preco_medio: "",
        nota_fiscal: "",
        data_nota_fiscal: "",
        numero_empenho: "",
        rede_fes: null,
        movimentos: [],
      },
      movimentos: [],
      tipo_movimentos: [],
      unidades: [],
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        language: "pt-br",
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "numberedlist",
          "bulletedlist",
          "|",
          "outdent",
          "indent",
          "|",
          "blockquote",
          "inserttable",
          "undo",
          "redo",
        ],
      },
    };
  },
  computed: {},
  methods: {
    setValidade(obj) {
      const self = this;

      self.lotes.forEach((element) => {
        if (element.lote == obj) {
          self.movimento.validade = element.validade;
          self.movimento.fabricante_id = element.fabricante_id;
          self.movimento.fornecedor_id = element.fornecedor_id;
        }
      });
    },
    getLotes() {
      const self = this;
      let api =
        self.$store.state.api +
        "estoques?paginated=false&material_id=" +
        self.movimento.material_id +
        "&with[]=fabricante&with[]=fornecedor";

      axios
        .get(api)
        .then((response) => {
          self.lotes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFabricantes() {
      const self = this;
      let api = self.$store.state.api + "fabricantes?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.fabricantes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFornecedores() {
      const self = this;
      let api = self.$store.state.api + "fornecedores?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.fornecedores = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    format_date(data) {
      if (data) {
        return moment(String(data)).format("YYYYMMDD");
      }
    },
    add: function () {
      const self = this;

      if (
        self.movimento.material_id &&
        self.movimento.quantidade &&
        self.movimento.validade &&
        self.movimento.fabricante_id &&
        self.movimento.fornecedor_id &&
        self.movimento.lote &&
        (self.movimento.tipo_movimento_id ? self.movimento.preco_medio : true)
      ) {
        var mov = {
          material_nome: $("#materiais").text().slice(0, -20),
          fabricante_nome: $("#fabricante").text().slice(0, -20),
          fornecedor_nome: $("#fornecedor").text().slice(0, -20),
          material: self.movimento.material_id,
          fabricante: self.movimento.fabricante_id,
          fornecedor: self.movimento.fornecedor_id,
          lote: self.movimento.lote,
          validade: self.movimento.validade,
          quantidade: self.movimento.quantidade,
          preco_medio: self.movimento.preco_medio,
        };

        self.movimentos.push(mov);
        self.movimento.movimentos[self.movimentos.length - 1] = mov;

        self.movimento.material_id = "";
        self.movimento.quantidade = "";
        self.movimento.fabricante_id = "";
        self.movimento.fornecedor_id = "";
        self.movimento.validade = "";
        self.movimento.lote = "";
        self.movimento.preco_medio = "";

        return true;
      } else {
        if (
          self.movimento.material_id ||
          self.movimento.quantidade ||
          self.movimento.fabricante ||
          self.movimento.fornecedor ||
          self.movimento.validade ||
          self.movimento.lote
        ) {
          self.$message(
            null,
            "Por favor preencha todos os campos do material",
            "error"
          );

          return false;
        }

        return true;
      }
    },
    remove: function (id) {
      const self = this;
      self.movimentos.splice(id, 1);
      self.movimento.movimentos.splice(id, 1);
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "movimentos";

      if (!self.add()) {
        return;
      }

      var last = self.movimento.tipo_movimento_id;

      self.movimento.tipo_movimento_id = self.movimento.tipo_movimento_id.id;

      axios
        .post(api, self.movimento)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/movimentos");
        })
        .catch((error) => {
          self.movimento.tipo_movimento_id = last;
          self.$message(null, error.response.data, "error");
        });
    },
    getMovimento: function (id) {
      const self = this;
      const api = self.$store.state.api + "movimentos/" + id;

      axios
        .get(api)
        .then((response) => {
          self.movimento = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTipoMovimentos: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_movimentacoes?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.tipo_movimentos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getMateriais: function () {
      const self = this;
      const api = self.$store.state.api + "materiais?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.materiais = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getMateriais();
    self.getFabricantes();
    self.getFornecedores();
    self.getTipoMovimentos();
    self.getUnidades();

    let id = self.$route.params.id;
    if (id) {
      self.getMovimento(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
